// // src/callLogApi.js — place in same folder as api.js
// import api from "./api/api";

// /* ── CALL LOGS ── */
// export const fetchCallLogs  = (params = {}) => api.get("/call-logs", { params });
// export const fetchCallLog   = (id)          => api.get(`/call-logs/${id}`);
// export const createCallLog  = (data)        => api.post("/call-logs", data);
// export const updateCallLog  = (id, data)    => api.put(`/call-logs/${id}`, data);
// export const deleteCallLog  = (id)          => api.delete(`/call-logs/${id}`);

// /* ── MIS REPORT ── */
// export const fetchMISReport = (params = {}) =>
//   api.get("/call-logs/mis/report", { params });
// src/callLogApi.js
import api from './api/api';

export const fetchCallLogs = (params) => api.get('/call-logs', { params });
export const getCallLog = (id) => api.get(`/call-logs/${id}`);
export const createCallLog = (data) => api.post('/call-logs', data);
export const updateCallLog = (id, data) => api.put(`/call-logs/${id}`, data);
export const deleteCallLog = (id) => api.delete(`/call-logs/${id}`);
export const fetchMISReport = (params) => api.get('/call-logs/mis/report', { params });
export const fetchMISReportDetails = (params) => api.get('/call-logs/mis/details', { params });

// Cross-module MIS dashboard (Leads/Properties/Deals/Documents/Payments/Tasks/
// Visits/Meetings, per agent) — reuses the same aggregation as the weekly
// email digest. See controllers/reportController.js → getMISDashboard.
export const fetchMISDashboard = (params) => api.get('/reports/mis-dashboard', { params });

// Raw records behind one "All Modules" card (leads/properties/deals/payments/
// documents/tasks/visits/meetings) — params: { module, period, from, to, userId }.
export const fetchMISModuleDetails = (params) => api.get('/reports/mis-dashboard/details', { params });

// Convert an "Interested" call log → Lead
export const convertCallToLead = (id, data) =>
  api.post(`/call-logs/${id}/convert-to-lead`, data);

// Call history timeline — all calls to one contact number (oldest → newest)
export const fetchCallTimeline = (contactNumber) =>
  api.get('/call-logs/timeline', { params: { contactNumber } });